<template>
  <el-dialog custom-class="system_manager_dialog"
             title="修改学员帐户"
             :visible.sync="flag"
             :close-on-click-modal="false"
             width="500px">
    <div class="main_con">
      <vue-scroll :ops="ops" ref="vs">
        <el-form ref="form"
                 :rules="rules"
                 :model="vitaForm"
                 class="form_con"
                 label-width="130px">
          <el-form-item label="身份有效证件号"
                        prop="id_number">
            <el-input size="medium"
                      v-model="vitaForm.id_number" disabled
                      placeholder="请输入正确的证件号"></el-input>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="mobile_phone">
            <el-input v-model="vitaForm.mobile_phone"
                      placeholder="请输入用户名/手机"></el-input>
          </el-form-item>
          <el-form-item label="姓名"
                        prop="name">
            <el-input v-model.trim="vitaForm.name"
                      placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="姓氏(拼音)"
            prop="family_name_spell">
            <el-autocomplete
                    v-if="id_type==='id_number'"
                    style="width: 100%"
                    v-model="vitaForm.family_name_spell"
                    :fetch-suggestions="familyNameSearch"
                    placeholder="请输入拼音大写,例如张三,输入:ZHANG"
            ></el-autocomplete>
            <el-input v-model.trim="vitaForm.family_name_spell" v-else
              placeholder="请输入拼音大写"></el-input>
          </el-form-item>
          <el-form-item label="名字(拼音)"
            prop="given_name_spell">
            <el-autocomplete
                    v-if="id_type==='id_number'"
                    style="width: 100%"
                    v-model="vitaForm.given_name_spell"
                    :fetch-suggestions="givenNameSearch"
                    placeholder="请输入拼音大写,例如张三,输入:SAN"
            ></el-autocomplete>
            <el-input v-else v-model.trim="vitaForm.given_name_spell"
              placeholder="请输入拼音大写"></el-input>
          </el-form-item>
          <el-form-item label="出生日期"
                        prop="birthday">
            <el-date-picker
              v-model="vitaForm.birthday"
              @change="changeHonorTime()"
              :picker-options="option"
              class="birthday"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="性别"
                        prop="gender">
            <el-radio-group v-model="vitaForm.gender">
              <el-radio label="Male">男</el-radio>
              <el-radio label="Female">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="新密码"
                        prop="password">
            <el-input v-model="vitaForm.password"
                      placeholder="不设置则不修改"
                      type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码"
                        prop="password_affirm">
            <el-input v-model="vitaForm.password_affirm"
                      placeholder="请确认新密码"
                      type="password"></el-input>
          </el-form-item>
          <el-form-item label="上传照片" prop="image_url" class="up-form-item">
            <div class="upfile-wrap">
              <image-up
                      :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
                      :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
                      :imgval.sync="vitaForm.image_url"
                      :cover='showImg'
                      :showScaleBig="false"
                      :default-img="DefaultImg"
                      :dt="'12vh'"
              ></image-up>
              <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
            </div>
          </el-form-item>
          <el-form-item label="上传身份证正面" prop="image_url" class="up-form-item">
            <div class="upfile-wrap id_car">
              <vita-photo :showScaleBig="false" :imgUrl.sync="vitaForm.id_card_front" :w="300" :h="160"></vita-photo>
            </div>
          </el-form-item>
          <el-form-item label="上传身份证反面" prop="image_url" class="up-form-item">
            <div class="upfile-wrap id_car">
              <vita-photo :showScaleBig="false" :imgUrl.sync="vitaForm.id_card_verso" :w="300" :h="160"></vita-photo>
            </div>
          </el-form-item>
          <div class="btns">
            <el-button type="primary" :loading="repeatSubmit"  @click="onSubmit">保存</el-button>
            <el-button type="danger" @click="onCancel">取消</el-button>
            <!-- <div class="btn save"
                 @click="onSubmit">保存
            </div> -->
            <!-- <div class="btn cancel"
                 @click="onCancel">取消
            </div> -->
          </div>
        </el-form>
      </vue-scroll>
    </div>

  </el-dialog>
</template>

<script>
  import {getPwdSalt} from "@/api/common/api";
  import {hex_hmac_sha256} from "@/assets/js/sha";
  import {editStudent} from "@/api/system_manager/api";
  import DefaultImg from '@/assets/images/person.png'
  import identify1 from "@/assets/images/vita/identify1.png";
  import identify2 from "@/assets/images/vita/identify2.png";
  const HOSTURL = process.env.VUE_APP_URL;
  import ops from "@/assets/js/vuescrollOption";
  import pinyin from '@/minix/pinyin'
  export default {
    name: "stu-edit",
    mixins:[pinyin],
    props: ["visible", "info"],
    components:{
      "image-up": () => import("@/components/UpImage/UpImage"),
      "vita-photo": () => import("@/components/UpImage/vita-upload"),
    },
    data() {
      return {
        repeatSubmit: false,
        canChangeName:true,
        DefaultImg,
        identify1,
        ops:ops(true),
        phone_flag: false, // 用于标记后台返回错误提示，进行重校验
        phone_msg: "", // 存储后台错误提示
        idCard_flag: false, // 标记后台返回错误提示，进行重校验
        idCard_tips: "", // 后台返回身份证重复提示
        // showImg: null, // 保存回显的用户头像
        showImg : this.info.profile_picture && HOSTURL + this.info.profile_picture,
        id_type: this.info.id_type,
        vitaForm: {
          user_id: this.info.user_id,
          name: this.info.name,
          family_name_spell: this.info.family_name_spell,
          given_name_spell: this.info.given_name_spell,
          mobile_phone: this.info.mobile_phone,
          gender: this.info.gender,
          id_number: this.info.id_number,
          password: "",
          password_affirm: "",
          image_url:"",
          id_card_front:this.info.id_card_photo_front ? HOSTURL+this.info.id_card_photo_front:identify1,
          id_card_verso:this.info.id_card_photo_verso ?  HOSTURL+this.info.id_card_photo_verso:identify2,
          birthday:this.info.birthday
        },
        option: {
          disabledDate: time => {
            return (
                    new Date(time).getTime()  > new Date().getTime() - 86400000
            );
          }
        },
        rules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
          ],
          family_name_spell: [
            {required: false,
              validator:(rule, value, callback) => {
                if(value){
                  (/^[a-zA-Z]+$/).test(value)
                    ? callback()
                    : callback(new Error('请输入拼音大写,例如张三,输入:ZHANG'));
                }else{
                  callback()
                }
              },
              trigger: 'change'},
            /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
          ],
          // 姓名
          given_name_spell: [
            {required: false,
              validator:(rule, value, callback) => {
                if(value){
                  (/^[a-zA-Z]+$/).test(value)
                    ? callback()
                    : callback(new Error('请输入拼音大写,例如张三,输入:SAN'));
                }else{
                  callback()
                }
              },
              trigger: 'change'},
            /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
          ],
          mobile_phone: [
            {
              required: true,
              validator: (rule, val, callback) => {
                if (this.$yioks.mobile_phone(val)) {
                  if (!this.phone_flag) {
                    callback();
                  } else {
                    this.phone_flag = false;
                    callback(new Error(this.phone_msg));
                  }
                } else {
                  callback(new Error('请输入有效的11位手机号'));
                }
              },
              trigger: "blur"
            }
          ],
          gender: [
            {required: true, message: '请选择性别', trigger: 'blur'},
            // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
          ],
          id_number: [
            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
            {
              required: false,
              validator: (rule, val, callback) => {
                /*if (this.$yioks.idCard_number(val)) {
                  if (!this.idCard_flag) {
                    callback();
                  } else {
                    this.idCard_flag = false;
                    callback(new Error(this.idCard_tips));
                  }
                } else {
                  callback(new Error("请输入正确的身份证信息"));
                }*/
                callback();
              },
              trigger: "blur"
            }
          ],
          password: [
            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
            {
              required: false,
              validator: (rule, val, callback) => {
                if (!val) {
                  callback();
                  return false;
                }
                if (this.$yioks.pwd(val)) {
                  callback();
                } else {
                  callback(new Error('8—16位字母（区分大小写）和数字组合'));
                }
              },
              trigger: "blur"
            }
          ],
          password_affirm: [
            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
            {
              required: false,
              validator: (rule, val, callback) => {
                if (val !== this.vitaForm.password) {
                  callback(new Error('两次输入密码不一致'));
                }
                if (!val) {
                  callback();
                  return false;
                }
                if (this.$yioks.pwd(val)) {
                  callback();
                }else {
                  callback(new Error('8—16位字母（区分大小写）和数字组合'));
                }

              },
              trigger: "blur"
            }
          ]
        }
      };
    },
    computed: {
      flag: {
        set(bool) {
          this.resetForm();
          this.$emit("flag", bool, false);
        },
        get() {
          return this.visible;
        },
      }
    },
    methods: {
      request(data) {
        editStudent(data)
          .then(res => {
            // console.log(res);
            // this.repeatSubmit = false;
            const {msg, status} = res.data;
            if (Number(status) == 0) {
              this.$emit("flag", false, true);
              // return;
            }
            if (Number(status) == 405 || Number(status) == 114) {
              this.phone_msg = msg;
              this.phone_flag = true;
              this.$refs["form"].validateField("mobile_phone");
            }
            if (Number(status) == 415) {
              // console.log(msg);
              this.idCard_tips = msg;
              this.idCard_flag = true;
              this.$refs["form"].validateField("id_number");
            }
            this.repeatSubmit = false;
          })
          .catch(err => {
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      onSubmit() {
        if (this.repeatSubmit) {
          return;
        }
        this.repeatSubmit = true;
        if (this.vitaForm.id_card_front===identify1||this.vitaForm.id_card_front === HOSTURL +this.info.id_card_photo_front){
          this.vitaForm.id_card_front=''
        }
        if (this.vitaForm.id_card_verso===identify2||this.vitaForm.id_card_verso ===HOSTURL + this.info.id_card_photo_verso){
          this.vitaForm.id_card_verso=''
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            // alert('submit!');
            if (this.vitaForm.password != "") {
              getPwdSalt({})
                .then((res) => {
                  // console.log(res);
                  if (Number(res.data.status) === 0) {
                    const {regist_salt} = res.data.result.data;
                    const pwd = hex_hmac_sha256(regist_salt, this.vitaForm.password).toUpperCase();
                    // 确认密码
                    const pwd_affirm = hex_hmac_sha256(regist_salt, this.vitaForm.password_affirm).toUpperCase();
                    // 解决密码闪动
                    const data = {...this.vitaForm, password: pwd , regist_salt: regist_salt,password_affirm: pwd_affirm};
                    this.request(data);
                    return;
                  }
                  throw new Error(res);
                })
                .catch((err) => {
                  this.repeatSubmit = false;
                  console.log(err);
                });
            } else {
              this.request(this.vitaForm);
            }
          } else {
            this.repeatSubmit = false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      onCancel() {
        this.flag = false;
      },
      resetForm() {
        this.$refs["form"].resetFields();
      },
      changeHonorTime(){
        let time = this.vitaForm.birthday;
        if(!time) {
          this.$set(this.vitaForm, "birthday", "");
        } else {
          time = this.$yioks.time(time,false);
          this.$set(this.vitaForm, "birthday", time);
        }
      },
    },
  }
</script>
<style lang="stylus" scoped>
@import "~@/assets/css/variable";
.el-button--danger
  background-color $color_err
.main_con
  height 550px
  .form_con
    margin-right 25px
    .birthday
      width 100%
  .id_car
    border 1px dashed $color_black
    border-radius 10px
</style>
